import axiosInstance from '../utils/AxiosConfig';

import { DEFAULT_CURRENCY, getActiveCurrency } from '../utils/currency';
export const getProductsReportData = async ({ from, to }) => {
  const response = await axiosInstance.get('/reports/products', { params: { from, to, ...(getActiveCurrency() !== DEFAULT_CURRENCY ? { currency: getActiveCurrency() } : {}) } });
  return response.data;
};
